import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { HubUser } from "@appcore/models/user";
import { NewsService, AuthenticationService, ProgressStatus, UserService } from "@appcore/service";
import { OktaAuthStateService } from "@okta/okta-angular";
import { ConfirmationService, MessageService } from "primeng/api";
import { BehaviorSubject, Subscription } from "rxjs";
import { trigger, state, style, transition, animate, AnimationEvent } from "@angular/animations";
import { AppMenuComponent } from "./app.menu.component";

@Component({
  selector: "app-topbar",
  templateUrl: "./app.topbar.component.html",
  styleUrls: ["../app.component.css"],
  animations: [
    trigger("overlayMenuAnimation", [
      transition(":enter", [
        style({ opacity: 0, transform: "scaleY(0.8)" }),
        animate(".12s cubic-bezier(0, 0, 0.2, 1)", style({ opacity: 1, transform: "*" }))
      ]),
      transition(":leave", [animate(".1s linear", style({ opacity: 0 }))])
    ])
  ],
  providers: [ConfirmationService, MessageService, ProgressStatus, NewsService]
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  @Input() parent: any;
  @Output() menuButtonClick: EventEmitter<any> = new EventEmitter();
  @ViewChild("topbarMenu") topbarMenu: ElementRef;
  @ViewChild("statusDialog", { static: true }) statusDialog: {
    visible: boolean;
  };

  // Just used to bind to the template
  Status: any = {
    Header: "Progress Status",
    Message: "Loading profile..."
  };

  @ViewChild("containerElement") containerElement: ElementRef;

  // User Elements
  isAuthenticated: BehaviorSubject<boolean>;
  currentUser: HubUser;
  userFullName = "";
  initials = "";
  userColor: string;
  orgName: string;

  // Security Levels
  contentCustomizerAccess = false;
  contentExporterAccess = false;
  sysAdminAccess = false;
  adminAccess = false;
  standardUser = false;
  contentAdminAccess = false;
  courseEditorAccess = false;

  loading = false;
  activeMenuIndex: number;
  outsideClickListener: any;
  subscription: Subscription;
  topBarOpenMenu = false;

  constructor(
    private router: Router,
    public authStateService: OktaAuthStateService,
    private authenticationService: AuthenticationService,
    private newsService: NewsService,
    public confirmationService: ConfirmationService,
    public messageService: MessageService,
    public progressStatus: ProgressStatus
  ) { }

  ngOnInit(): void {
    this.dataProgressStart();
    this.populateUserInfo();
    this.dataProgressComplete();
  }

  populateUserInfo(): void {
	this.authenticationService.getCurrentUserValue().subscribe((currentUser) => {
		this.currentUser = currentUser;
		this.isAuthenticated = this.authenticationService.$authed;
		console.log("Populating User Info & Checking Permissions");
		this.userFullName = <string>currentUser.FirstName + " " + <string>currentUser.LastName;
		this.initials = currentUser.Initials as string;
		this.userColor = currentUser.ChipColor as string;
		this.orgName = currentUser.OrgName as string;
	});
  }

  exit(): void {
    this.confirmationService.confirm({
      key: "logout",
      icon: "pi pi-exclamation-triangle",
      header: "Confirm Sign-out",
      message:
        "By signing-out of the PLS HUB, you will also be signed-out of the Children's Hospital Association (CHA) Member Site and all other associated CHA web site services.<br><br>Click <b>Yes</b> to Sign Out or <b>No</b> to Cancel.",
      accept: () => {
        this.authenticationService.logout();
      }
    });
  }

  onMenuButtonClick(event: Event): void {
    this.menuButtonClick.emit();
    //console.log(`this.appMenu.menuActive: ${this.parent.appMenu.menuActive}`);

    if (this.parent.appMenu.menuActive === true) {
      this.parent.appMenu.closeMenu();
    } else {
      this.parent.appMenu.openMenu();
    }
    
    event.preventDefault();
  }

  bindOutsideClickListener(): void {
    if (!this.outsideClickListener) {
      this.outsideClickListener = event => {
        if (this.isOutsideTopbarMenuClicked(event)) {
          this.activeMenuIndex = null;
        }
      };

      document.addEventListener("click", this.outsideClickListener);
    }
  }

  unbindOutsideClickListener(): void {
    if (this.outsideClickListener) {
      document.removeEventListener("click", this.outsideClickListener);
      this.outsideClickListener = null;
    }
  }

  toggleMenu(event: Event, index: number): void {
    this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
    event.preventDefault();
  }

  isOutsideTopbarMenuClicked(event): boolean {
    return !(
      this.topbarMenu.nativeElement.isSameNode(event.target) || this.topbarMenu.nativeElement.contains(event.target)
    );
  }

  onOverlayMenuEnter(event: AnimationEvent): void {
    switch (event.toState) {
      case "visible":
        this.bindOutsideClickListener();
        break;

      case "void":
        this.unbindOutsideClickListener();
        break;
    }
  }

  dataProgressStart(): void {
    this.Status.Message = this.progressStatus.getSentMessage();
    this.loading = true;
  }
  dataProgressUpdate(): void {
    this.Status.Message = this.progressStatus.getReceivedMessage();
  }
  dataProgressComplete(): void {
    setTimeout(() => {
      this.messageService.clear();
    }, 500);
    this.loading = false;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
